import axios from 'axios'

const request = axios.create({
   baseURL: 'https://youtube.googleapis.com/youtube/v3/',
   params: {
      key: 'AIzaSyBzICqbfXxMCKX-77WMpqK06vaLXiFgJnM',
   },
})

export default request